import Button from '@ui/Button';
import React, { useRef } from 'react';
import Typography from '@ui/Typography';
import AvatarEditor from '@ui/AvatarEditor';

function NonProfitOnBoardFormEditAvatarStep(props) {
  const { image, onSubmit } = props;
  const [editor, setEditor] = React.useState(null);
  const setEditorRef = (e) => setEditor(e);

  const handleSave = () => {
    if (editor) {
      const canvas = editor.getImageScaledToCanvas();
      canvas.toBlob((blob) => {
        const editedImage = new File([blob], 'edited-image.png', {
          type: 'image/png',
        });
        onSubmit(editedImage);
      }, 'image/png');
    }
  };

  return (
    <div className="flex flex-col gap-12 flex-1 w-full">
      <Typography variant="h1" component="h2">Edit Profile Picture</Typography>
      <div className="flex flex-col gap-6">
        <AvatarEditor image={image} setEditorRef={setEditorRef} />
        <Button
          variant="filled"
          color="primary"
          type="button"
          onClick={handleSave}>
          Save
        </Button>
      </div>
    </div>
  );
}

export default NonProfitOnBoardFormEditAvatarStep;
